module.exports = __webpack_public_path__ + "img/fitt_dark_clear_cropped.ba16445c.png";